import React from 'react'
import PaymentPage from '../containers/PaymentPage/PaymentPage'
import Seo from '../common/Components/Seo/Seo'
import PaymentSchema from '../common/Components/StructuredData/PaymentSchema'

const Payment = () => {
  return (
    <div>
        <Seo
          seo={{
            title: "Secure Payment | Complete Your Airport Parking Booking | Airport Parking Deals",
            description: "Complete your secure airport parking payment with encrypted SSL checkout. Multiple payment options accepted. Instant confirmation sent to your email.",
            keywords: "secure payment, airport parking payment, SSL encrypted checkout, booking payment, pay for parking, secure transaction"
          }}
        />
        <PaymentSchema />
        <PaymentPage/>
    </div>
  )
}

export default Payment
